<template>
  <div class="wxwork">
    <div class="box">
      <img src="../assets/images/view.png" alt="">
      <p>请在学校企业号中使用云订餐</p>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {

      }
    },
    created() {
    }

  }
</script>
<style scoped>
  .wxwork{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .28rem;
    color: #4A4A4A;
    background-color: #fff;
  }
  .wxwork .box{
    width: 3.86rem;
  }
  .wxwork .box img{
    width: 100%;
    padding-bottom: .4rem;
  }
</style>



// WEBPACK FOOTER //
// wxWork.vue?177b0cdb